import { createFileRoute } from '@tanstack/react-router';
import {
  fetchProductTraceByPurchaseOrderId,
  fetchTraceGraphByPurchaseOrderId,
} from '@/api/orders';
import { OrderProductTracingTab } from '@/app/(client)/orders/-components/OrderProductTracingTab';
import {
  productTraceKeys,
  useProductTraceByPurchaseOrderId,
} from '@/app/(client)/orders/-hooks/useProductTrace';
import { useTraceGraphByPurchaseOrderId } from '@/app/(client)/orders/-hooks/useTraceGraphByPurchaseOrderId';
import { traceGraphKeys } from '@/app/(client)/orders/-hooks/useTraceGraphBySalesOrderId';
import { Skeleton } from '@/components/ui/skeleton';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products',
)({
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: productTraceKeys.detail(params.poId),
        queryFn: () => fetchProductTraceByPurchaseOrderId(params.poId),
      }),
      queryClient.ensureQueryData({
        queryKey: traceGraphKeys.detail(params.poId),
        queryFn: () =>
          fetchTraceGraphByPurchaseOrderId(params.poId).then(r => r.data),
      }),
    ]),
  component: PurchaseOrderProductsRoute,
});

function PurchaseOrderProductsRoute() {
  const { poId } = Route.useParams();
  const { data: productTrace, isLoading } =
    useProductTraceByPurchaseOrderId(poId);
  const { data: traceGraph } = useTraceGraphByPurchaseOrderId(poId);

  const tracingMeta = traceGraph?.meta
    ? { type: traceGraph.meta.type, orderId: traceGraph.meta.orderId }
    : undefined;

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-96' />
      </div>
    );
  }

  return (
    <OrderProductTracingTab
      data={productTrace ?? { layers: [], links: [] }}
      orderId={poId}
      {...(tracingMeta ? { tracingMeta } : {})}
    />
  );
}
